import { defineStore } from "pinia";
import { update } from "@/modules/tenantAdmin/companyDetails/api";
import * as Sentry from "@sentry/vue";
import { MetaTenantAdminShowResource } from "@/modules/shared/meta/types";
import { computed, ref } from "vue";
import { useMetaStore } from "@/application/stores/meta";
import { useApp } from "@/application/composables/app";
import { useRouter } from "vue-router";

export const useOnboardingStore = defineStore("onboarding", () => {
  const metaStore = useMetaStore();
  const { appData } = useApp();
  const router = useRouter();

  const backUrl = ref<unknown>();

  const hasOnboardingFlowStarted = computed(
    () =>
      metaStore.meta &&
      (metaStore.meta as MetaTenantAdminShowResource).hasOnboardingFlowStarted,
  );

  const markOnboardingAsFinished = async () => {
    metaStore.meta = {
      ...metaStore.meta,
      hasOnboardingFlowStarted: true,
    };

    try {
      await update({
        hasOnboardingFlowStarted: true,
      });
    } catch (error: unknown) {
      Sentry.captureException(error);
    }
  };

  const endOnboardingAndNavigateBack = () => {
    const url = backUrl.value;
    backUrl.value = undefined;

    markOnboardingAsFinished();

    if (!url || String(url).startsWith("/onboarding")) {
      router.replace(appData.landingPage);
      return;
    }

    router.replace(String(url));
  };

  const configureBackUrl = () => {
    backUrl.value = router.options.history.state.back;
  };

  return {
    hasOnboardingFlowStarted,
    endOnboardingAndNavigateBack,
    configureBackUrl,
  };
});
